import React, { useEffect, useState } from 'react';
import styles from './AllMembersTab.module.scss';
import { Box, ButtonBase, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Filter } from '../Filter';
import { Map } from '../../../../modules/tt-map';
import ListMode from '../ListMode';
import GridMode from '../GridMode';
import { Button } from 'tt-ui-lib/core';
import { OrdersIcon, UpIcon, DownIcon } from 'tt-ui-lib/icons';
import { AppAvatar } from 'components/Avatar';

export const AllMembersTab = ({ allMembers }) => {
  const router = useNavigate();
  const mapApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  const [loading, setLoading] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [getMore, setGetMore] = useState(false);
  const [filters, setFilters] = useState({
    limit: 15,
    order_dir: 'desc',
    page: 1,
    q: '',
  });
  const [newConnectedUsers, setNewConnectedUsers] = useState(allMembers);
  const [activeMode, setActiveMode] = useState(
    localStorage.getItem('mode') ? localStorage.getItem('mode') : 'list'
  );
  const result = false;

  useEffect(() => {
    if (viewAll) {
      setNewConnectedUsers(allMembers);
    } else {
      setNewConnectedUsers((current) => current.slice(0, 2));
    }
  }, [viewAll]);
  const fetchMoreAdmins = async () => {
    if (page < pageCount && !loading) {
      const pageNumber = page + 1;
      setPage(pageNumber);
      setGetMore(true);
      setFilters({ ...filters, page: pageNumber });
    }
  };

  const onScrollAdmins = async (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const maxScroll = scrollHeight - scrollTop - 1;
    if (maxScroll <= clientHeight) {
      await fetchMoreAdmins();
    }
  };
  return (
    <>
      <Box className={styles.newConnectionsBlock}>
        <Box className={styles.title}>New Connections</Box>
        <Box className={styles.connectedUsers}>
          {newConnectedUsers.map((user) => (
            <Box className={styles.connectItem}>
              <Box className={styles.infoBlock}>
                <AppAvatar
                  userName={`${user.first_name} ${user.last_name}`}
                  role={user.roles && user.roles[0]?.name}
                  src={user.avatar}
                  nav={0}
                  size="sm"
                />
                <Box className={styles.userInfo}>
                  <Box className={styles.userName}> {`${user.first_name} ${user.last_name}`}</Box>
                  <Box className={styles.invitedBy}>Invited by {user.inviter}</Box>
                  <Box className={styles.experiences}>
                    <OrdersIcon style={{ marginRight: 5, width: 14, height: 14 }} />
                    <Typography className={styles.experienceName}>
                      {user.experiences[0]?.title} of{' '}
                      <Typography className={styles.greenText}>
                        {user.experiences[0]?.company_name}
                      </Typography>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className={styles.connectionActions}>
                <Button type="default" className={styles.btn}>
                  accept
                </Button>
                <Button type="link" className={styles.btn}>
                  reject
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
        <Box className={styles.viewAllBlock}>
          <ButtonBase className={styles.viewAllButton} onClick={() => setViewAll(!viewAll)}>
            <Typography className={styles.text}>View all</Typography>
            <Box className={styles.downIcon}>{viewAll ? <UpIcon /> : <DownIcon />}</Box>
          </ButtonBase>
        </Box>
      </Box>
      <Box className={styles.filtersAndList}>
        <Filter activeMode={activeMode} changeActiveMode={(mode) => setActiveMode(mode)} />
        <Box className={styles.foundedCount}>{allMembers.length} people were found by request</Box>
        {activeMode === 'map' &&
          !loading &&
          (result ? (
            <Box
              sx={{
                height: '100%',
                borderRadius: 4,
                display: 'flex',
                justifyContent: 'center',
                my: 2,
                p: 2,
                backgroundColor: '#FFFFFF',
              }}
            >
              <Map
                clickMarker={(id) => router(`/dashboard/profile/${id}`)}
                showSearch={false}
                isList
                coordinatesList={result}
                apiKey={mapApiKey}
              />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
              <Typography>List is empty</Typography>
            </Box>
          ))}
        <Box>
          {activeMode === 'list' && (
            <ListMode loading={scrollLoading} onScroll={onScrollAdmins} users={allMembers} />
          )}
          {activeMode === 'grid' && (
            <GridMode loading={scrollLoading} onScroll={onScrollAdmins} users={allMembers} />
          )}
        </Box>
      </Box>
    </>
  );
};
